// * GET =====================================
export const ROLE_GET = (roleId: string) => `/role/${roleId}`;

export const ROLE_GET_MODULE_COMPONENTS = `/role/module_components`;

// * PATCH ===================================

// * POST ====================================
export const ROLE_POST = (roleId: number) => `/role/${roleId}`;

// * DELETE ==================================
export const ROLE_DELETE = (roleId: string) => `/role/${roleId}`;
// * PUT =====================================
export const ROLE_PUT = `/role`;
